import React, { useState } from 'react';
import { Modal, Typography } from '@lamimed/pantheon';

import { Stepper } from 'components/Stepper';

import { useFormSubmit } from './hooks/useFormSubmit';
import { usePrescriptionModal } from './hooks/usePrescriptionModal';
import { PrescriptionUploadProvider } from './hooks/usePrescriptionUpload';
import { PersonalInfo } from './Personalnfo';
import { PrescriptionSuccess } from './PrescriptionSuccess';
import { UploadFiles } from './UploadFiles';

import * as S from './styles';

export const PrescriptionModal: React.FC = () => {
  const {
    isPrescriptionModalOpen,
    setIsPrescriptionModalOpen,
    isPrescriptionSucceeded,
    setIsPrescriptionSucceeded,
  } = usePrescriptionModal();
  const [currentStep, setCurrentStep] = useState(1);
  const { loading } = useFormSubmit();

  return (
    <PrescriptionUploadProvider>
      <Modal
        open={isPrescriptionModalOpen}
        onClose={() => setIsPrescriptionModalOpen(false)}
        size="small"
        dismissible
      >
        {isPrescriptionSucceeded ? (
          <PrescriptionSuccess
            onFinish={() => setIsPrescriptionModalOpen(false)}
          />
        ) : (
          <>
            {currentStep === 1 && (
              <UploadFiles setCurrentStep={setCurrentStep} loading={loading} />
            )}

            {currentStep === 2 && (
              <PersonalInfo
                onDone={() => setIsPrescriptionSucceeded(true)}
                setCurrentStep={setCurrentStep}
                currentStep={currentStep}
              />
            )}

            <S.StepperContainer>
              <Stepper currentStep={currentStep} steps={2}>
                <S.TextContainer opactity="35%">
                  <Typography color="text__highlight" variant="body_text_3">
                    Passo {currentStep} di 2
                  </Typography>
                </S.TextContainer>
              </Stepper>
            </S.StepperContainer>
          </>
        )}
      </Modal>
    </PrescriptionUploadProvider>
  );
};
